__turbopack_context__.v({
  "className": "open_sans_47b7811f-module__fMLf5q__className",
  "variable": "open_sans_47b7811f-module__fMLf5q__variable",
});
